// extracted by mini-css-extract-plugin
module.exports = {"EditorButton":"EditorButton_EditorButton__6JFiF","EditorButtonActive":"EditorButton_EditorButtonActive__x5tt3 EditorButton_EditorButton__6JFiF"};